import React, { useCallback } from 'react';
import { ScrollElement } from '@prisjakt/ui-scroll';

import { trackClosingSidebar } from '../../../sidebar/tracking';
import { VIEWS } from '../../../sidebar/components/sidebar-mobile/constants';

import * as S from './styles';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  closeMenu: () => void;
  showSidebar?: boolean;
  currentView: VIEWS;
};

const Menu = ({
  children,
  style,
  closeMenu,
  showSidebar,
  currentView,
}: Props) => {
  const onCloseMenu = useCallback(() => {
    trackClosingSidebar(currentView, 'MobileCloseButtonOrClickOutside');
    closeMenu();
  }, [currentView, closeMenu]);

  return (
    <S.OutsideClickTracker
      active
      onClickOutside={onCloseMenu}
      onEscapeKey={closeMenu}
      sidebar={showSidebar}
    >
      <S.MobileMenu
        sidebar={Boolean(showSidebar)}
        style={style}
        data-test="MobileMenu"
      >
        <ScrollElement name="Mobile Menu">{children}</ScrollElement>
      </S.MobileMenu>
    </S.OutsideClickTracker>
  );
};

export default Menu;
